import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { initEligibleProductsSuccessAction, snapStore } from 'containers/Snaps/Snap/store';
import { MilesTable } from 'components';

import { useGetRequest } from 'hooks';

import { DashboardEligibleProducts } from 'codegen';

import { columns } from './lib';

export const EligibleProducts = () => {
  const { snapId } = useParams();

  const refetchEligibleProductsData = snapStore((state) => state.refetchEligibleProductsData);

  const { data, loading, refresh } = useGetRequest<DashboardEligibleProducts>({
    url: `/snaps/${snapId}/products`,
    options: {
      refreshDeps: [snapId],
      onSuccess: ({ data: response }) => initEligibleProductsSuccessAction(response.eligibleProducts),
    },
  });

  useEffect(() => {
    if (refetchEligibleProductsData) {
      refresh();
    }
  }, [refetchEligibleProductsData]);

  return (
    <MilesTable
      size='small'
      title='Eligible Products'
      rowKey='productName'
      loading={loading}
      columns={columns}
      dataSource={data?.eligibleProducts}
    />
  );
};
